import TextBox from "../../forms/inputs/TextBox";
import EditorInput from "./EditorInput";
import { EditorInputProps } from "./EditorInput";

const EditorTextInput = ({
  name,
  inputTitle,
  details,
  placeholder,
  required,
  type
}: EditorInputProps & {
  placeholder?: string;
  type?: string;
}) => (
  <EditorInput
    name={name}
    inputTitle={inputTitle}
    required={required}
  >
    <TextBox
      name={name}
      className="rounded border-[1px] bg-white border-ctb-grey-700 px-4 py-2"
      errorClassName="border-ctb-red-500"
      placeholder={placeholder}
      type={type}
      rules={{
        required
      }}
    />

    {details && <p className="text-sm text-ctb-grey-600 ">{details}</p>}
  </EditorInput>
);

export default EditorTextInput;
